import { useContext } from 'react'

import KanbanListContext from 'contexts/KanbanListContext'

const useKanbanList = () => {
  const context = useContext(KanbanListContext)

  if (context === undefined) {
    throw new Error('useKanbanList must be used within a KanbanListProvider')
  }

  return context
}

export default useKanbanList
